






















import Engine, { Phase, Player } from "@gaia-project/engine";
import { Component, Vue } from "vue-property-decorator";
import { phaseBeforeSetupBuilding } from "../logic/utils";
import PlayerCircle from "./PlayerCircle.vue";

@Component({
  components: { PlayerCircle },
})
export default class TurnOrder extends Vue {
  get gameData(): Engine {
    return this.$store.state.data;
  }

  get turnOrder(): Player[] {
    const data = this.gameData;
    if (phaseBeforeSetupBuilding(data)) {
      return data.players;
    }
    if (data.phase === Phase.SetupBuilding || data.phase === Phase.SetupBooster) {
      return data.setup.map((faction) => data.players.find((pl) => pl.faction === faction));
    }
    return data.turnOrder.map((player) => data.players[player]);
  }

  get passedPlayers(): Player[] {
    return (this.gameData.passedPlayers ?? []).map((player) => this.gameData.player(player));
  }
}
